<template>
  <div id="rolelist">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div slot="header" class="clearfix dettit">
          <span>权限管理&nbsp;/&nbsp;管理员列表</span>
          <el-button type="success" @click="adddata('user:add')"
            >添加</el-button
          >
        </div>
        <el-dialog
          :title="titname"
          :visible.sync="dialogFormVisible"
          width="60%"
        >
          <el-form>
            <el-form-item label="* 账号：" :label-width="formLabelWidth">
              <el-input
                v-model="username"
                auto-complete="off"
                :disabled="titname == '编辑管理员'"
                placeholder="请输入账号（推荐使用英文）"
              ></el-input>
            </el-form-item>
            <el-form-item label="* 密 码：" :label-width="formLabelWidth">
              <el-input
                v-model="password"
                type="password"
                auto-complete="off"
                placeholder="请输入密码（6-18位）"
              ></el-input>
            </el-form-item>
            <el-form-item label="* 角 色：" :label-width="formLabelWidth">
              <el-select
                v-model="roleIds1"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.roleIds"
                  :label="item.roleName"
                  :value="item.roleIds"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="* 姓名/昵称：" :label-width="formLabelWidth">
              <el-input v-model="nickname" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item
              label="* 管理的地区："
              v-if="modify"
              :label-width="formLabelWidth"
            >
              <p>
                {{ areasName
                }}<a
                  style="
                    color: red;
                    text-decoration: underline;
                    margin-left: 20px;
                  "
                  @click="adddz"
                  >重新添加</a
                >
              </p>
            </el-form-item>
            <el-form-item
              label="* 管理地区："
              :label-width="formLabelWidth"
              class="now nows"
              v-if="stat == 1"
            >
              <el-select
                v-model="pro"
                value-key="id"
                @change="sheng($event)"
                multiple
                placeholder="省份"
                class="slt"
              >
                <el-option
                  v-for="item in prolist"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="city"
                value-key="id"
                @change="shi"
                multiple
                placeholder="城市"
                class="slt"
              >
                <el-option
                  v-for="item in citylist"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="area"
                value-key="id"
                @change="qu($event)"
                multiple
                placeholder="区/县"
                class="slt"
              >
                <el-option
                  v-for="item in arealist"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="town"
                value-key="id"
                @change="xiang($event)"
                multiple
                placeholder="街道/乡镇"
                class="slt"
              >
                <el-option
                  v-for="item in townlist"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                v-model="village"
                value-key="id"
                @change="cun($event)"
                placeholder="社区/村"
                multiple
                class="slt"
              >
                <el-option
                  v-for="item in villagelist"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="sub">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <Week @childFn="parentFn"></Week>
      <el-select v-model="roleIds" placeholder="角色类型" class="elinputs">
        <el-option
          v-for="item in roleList"
          :key="item.roleIds"
          :label="item.roleName"
          :value="item.roleIds"
        >
        </el-option>
      </el-select>
      <el-select v-model="deleteStatus" placeholder="状态" class="elinputs">
        <el-option
          v-for="item in statlist"
          :key="item.deleteStatus"
          :label="item.label"
          :value="item.deleteStatus"
        >
        </el-option>
      </el-select>
      <el-date-picker
        style="margin: 0 16px 0 0"
        v-model="zctime"
        type="daterange"
        value-format="yyyy-MM-dd"
        @blur="time"
        range-separator="至"
        start-placeholder="创建开始日期"
        end-placeholder="创建结束日期"
      >
      </el-date-picker
      ><el-button
        type="primary"
        element-loading-text="加载中..."
        element-loading-background="rgba(0, 0, 0, 0.4)"
        v-loading.fullscreen.lock="fullscreenLoading"
        @click="query"
        >查询</el-button
      >
      <el-button type="info" @click="reset" style="margin: 10px 10px 16px"
        >重置</el-button
      >
      <el-table
        :data="tableData"
        border
        stripe
        :sort-method="sortChange1"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" :index="1" width="80">
        </el-table-column>
        <el-table-column prop="nickname" label="姓名/昵称" width="120">
        </el-table-column>
        <el-table-column prop="username" label="账号" width="120">
        </el-table-column>
        <el-table-column prop="areasName" label="所属地区" width="200">
        </el-table-column>
        <el-table-column label="角色" width="120">
          <template slot-scope="scope">
            <el-tag type="success">{{ scope.row.roleName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="addName" label="创建者" width="120">
        </el-table-column>
        <el-table-column label="状态" width="120">
          <template slot-scope="scope">
            <span
              class="boldfont"
              v-if="scope.row.deleteStatus == '1'"
              style="color: #67c23a"
              >启用</span
            >
            <span
              class="boldfont"
              v-if="scope.row.deleteStatus == '3'"
              style="color: #f56c6c"
              >禁用</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          sortable
          :formatter="timestampToTime"
          min-width="120"
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          min-width="120"
          sortable
          label="更新时间"
        >
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope" v-if="userdata.id != scope.row.userId">
            <el-button
              size="mini"
              v-if="scope.row.userId != 1"
              type="success"
              @click="handleEdit(scope.row, 'user:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              size="mini"
              v-if="scope.row.userId != 1 && scope.row.deleteStatus == 1"
              type="info"
              @click="prohibit(scope.row, 3)"
              ><i class="el-icon-remove"></i> 禁用</el-button
            >
            <el-button
              size="mini"
              v-if="scope.row.userId != 1 && scope.row.deleteStatus == 3"
              style="
                background: #409eff;
                color: #fff;
                border: 1px solid #409eff;
              "
              @click="prohibit(scope.row, 1)"
              ><i class="el-icon-remove"></i> 启用</el-button
            >
            <el-button
              size="mini"
              v-if="scope.row.userId != 1"
              type="danger"
              @click="det(scope.row, 'user:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <span
          >共 <i class="pagingNum">{{ listnum }}</i> 条</span
        >
        <Paging :gopage="listnum" @pag="pag"></Paging>
      </div>
    </el-card>
  </div>
</template>
<script>
import Week from "@/components/Week";
import Paging from "@/components/Paging";
export default {
  components: {
    Week,
    Paging,
  },
  name: "rolelist",
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      statlist: [
        {
          deleteStatus: "1",
          label: "启用",
        },
        {
          deleteStatus: "3",
          label: "禁用",
        },
      ],
      adminAreasId: "",
      tableData: [],
      name: "",
      dialogFormVisible: false,
      roleName: null,
      formLabelWidth: "120px",
      options: [],
      roleIds1: "", //角色id
      nickname: null, //昵称
      password: null, //密码
      username: null, //用户名
      areasName: "",
      userdata: {},
      region: [],
      pro: [],
      prolist: [],
      city: [],
      citylist: [],
      area: [],
      arealist: [],
      town: [],
      townlist: [],
      village: [],
      villagelist: [],
      level: "",
      stat: "0",
      modify: false,
      userId: "",
      areaId: "",
      deleteStatus: "", //管理员状态
      zctime: "",
      fullscreenLoading: true,
      titname: "添加管理员",
      roleList: [],
      roleIds: "",
      listnum: 1,
      btn: [],
    };
  },
  created() {
    this.initial();
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    // console.log(this.$route.query.id)
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem("region"));
    this.$set(this, "region", region);
    region.forEach((x) => {
      if (x.level == 0) {
        this.prolist.push(x);
      }
    });
    // 查询角色，用于分配
    this.$axios
      .post(
        `/api-r/permission/getAllRoleInfo/${this.userdata.areasId}`,
        {},
        { headers: { accessToken: this.userdata.token } }
      )
      .then((res) => {
        this.fullscreenLoading = false;
        this.$set(this, "roleList", res.data.roleInfoList);
        this.$set(this, "options", res.data.roleInfoList);
      });
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  methods: {
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.initial();
    },
    sortChange1(a, b) {
      console.log(a, b);
    },
    prohibit(row, i) {
      let data = this.$qs.stringify({
        deleteStatus: i,
        id: row.userId,
      });
      this.$axios
        .post(`/api-r/sys/updateSys`, data, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          if (res.data.success) {
            if (i == 3) {
              this.$message({
                type: "success",
                message: "禁用成功",
              });
            } else {
              this.$message({
                type: "success",
                message: "启用成功",
              });
            }
            this.initial();
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    // 查询
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.initial();
    },
    reset() {
      this.$router.push("/refresh");
    },
    parentFn(i) {
      this.areaId = i.id;
    },
    timestampToTime(row, column) {
      var date = new Date(row.createTime); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    det(row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将删除该管理员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              `/api-r/sys/updateSys`,
              this.$qs.stringify({ id: row.userId, deleteStatus: 2 }),
              { headers: { accessToken: this.userdata.token } }
            )
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.initial();
              } else {
                this.$message(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    adddata(hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$set(this, "stat", 1);
      this.$set(this, "roleName", null);
      this.$set(this, "username", null);
      this.$set(this, "roleId", null);
      this.$set(this, "password", null);
      this.$set(this, "nickname", null);
      this.$set(this, "areasName", null);
      this.$set(this, "titname", "添加管理员");
      this.dialogFormVisible = true;
      this.modify = false;
    },
    adddz() {
      this.stat = 1;
    },
    initial() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      // console.log(userdata)
      this.$set(this, "userdata", userdata);
      this.$set(this, "adminAreasId", userdata.areasId);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        adminAreasId: this.adminAreasId,
        areaId: this.areaId,
        roleId: this.roleIds,
        deleteStatus: this.deleteStatus,
        startTime: this.zctime[0],
        endTime: this.zctime[1],
        adminId: JSON.parse(sessionStorage.getItem("userdata")).id,
      });
      this.$axios
        .post(`/api-r/sys/getSysListInfo`, data, {
          headers: { accessToken: userdata.token },
        })
        .then((res) => {
          // console.log(res)
          this.fullscreenLoading = false;
          this.$set(this, "tableData", res.data.pageInfo.list);
          this.$set(this, "listnum", res.data.pageInfo.total);
        });
    },
    handleEdit(row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$set(this, "roleName", row.roleName);
      this.$set(this, "username", row.username);
      this.$set(this, "roleIds1", row.roleId);
      this.$set(this, "nickname", row.nickname);
      this.$set(this, "areasName", row.areasName);
      this.$set(this, "stat", 0);
      this.$set(this, "userId", row.userId);
      this.$set(this, "titname", "编辑管理员");
      this.modify = true;
      this.dialogFormVisible = true;
    },
    time() {
      console.log(this.zctime);
    },
    sub() {
      if (!this.modify) {
        if (this.nickname == null) {
          return this.$message("请输入角色名");
        }
        if (this.password == null) {
          return this.$message("请输入密码");
        }
        if (this.roleIds1 == null) {
          return this.$message("请选择角色");
        }
        if (this.username == null) {
          return this.$message("请输入用户名");
        }
        if (this.pro == "") {
          return this.$message("请选择省级分配");
        }
        if (this.$Public.isPwd(this.password) == false) {
          return this.$message("请输入6-18位登录密码");
        }
      }
      if (this.pro != "") {
        if (this.userdata.level == 1) {
          if (this.pro == "" || this.city == "") {
            return this.$message("请完善省级和市级分配");
          }
        }
        if (this.userdata.level == 2) {
          if (this.pro == "" || this.city == "" || this.area == "") {
            return this.$message("请完善省级、市级、区域分配");
          }
        }
        if (this.userdata.level == 3) {
          if (
            this.pro == "" ||
            this.city == "" ||
            this.area == "" ||
            this.town == ""
          ) {
            return this.$message("请完善省级、市级、区域、乡/镇分配");
          }
        }
        if (this.userdata.level == 4) {
          if (
            this.pro == "" ||
            this.city == "" ||
            this.area == "" ||
            this.town == "" ||
            this.village == ""
          ) {
            return this.$message("请完善省级、市级、区域、乡/镇、村分配");
          }
        }
        let arr = [];
        this.pro.forEach((x) => {
          arr.push(x);
        });
        if (this.city != "") {
          this.city.forEach((x) => {
            arr.push(x);
          });
        }
        if (this.area != "") {
          this.area.forEach((x) => {
            arr.push(x);
          });
        }
        if (this.town != "") {
          this.town.forEach((x) => {
            arr.push(x);
          });
        }
        if (this.village != "") {
          this.village.forEach((x) => {
            arr.push(x);
          });
        }
        let newarr = [];
        if (this.village == "") {
          if (this.town == "") {
            if (this.area == "") {
              if (this.city == "") {
                newarr = this.pro;
              } else {
                newarr = this.city;
              }
            } else {
              newarr = this.area;
            }
          } else {
            newarr = this.town;
          }
        } else {
          newarr = this.village;
        }
        let areasId = [];
        let areasName = [];
        let areasExtend = [];
        arr.forEach((x) => {
          areasId.push(x.id);
          areasName.push(x.name);
        });
        newarr.forEach((x) => {
          areasExtend.push(x.id);
        });
        let data1 = this.$qs.stringify({
          areasId: areasExtend.join(","),
          areasName: areasName.join(","),
          level: this.level,
          nickname: this.nickname,
          password: this.password,
          roleId: this.roleIds1,
          username: this.username,
          areasExtend: areasId.join(","),
          adminId: JSON.parse(sessionStorage.getItem("userdata")).id,
        });
        let data2 = this.$qs.stringify({
          areasId: areasExtend.join(","),
          areasName: areasName.join(","),
          level: this.level,
          nickname: this.nickname,
          password: this.password,
          roleId: this.roleIds1,
          username: this.username,
          areasExtend: areasId.join(","),
          id: this.userId,
        });
        if (this.modify) {
          this.$axios
            .post(`/api-r/sys/updateSys`, data2, {
              headers: { accessToken: this.userdata.token },
            })
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.initial();
                this.dialogFormVisible = false;
              } else {
                this.$message(res.data.msg);
              }
            });
        } else {
          this.$axios
            .post(`/api-r/sys/addSys`, data1, {
              headers: { accessToken: this.userdata.token },
            })
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.initial();
                this.dialogFormVisible = false;
              } else {
                this.$message(res.data.msg);
              }
            });
        }
      } else {
        // 省不选的情况，只有在编辑才会出现
        if (this.password != undefined) {
          if (this.password != "") {
            if (this.$Public.isPwd(this.password) == false) {
              return this.$message("请输入6-18位登录密码");
            }
          }
        }
        let data2 = this.$qs.stringify({
          areasId: null,
          areasName: null,
          level: null,
          areasExtend: null,
          nickname: this.nickname,
          password: this.password,
          roleId: this.roleIds1,
          username: this.username,
          id: this.userId,
        });
        this.$axios
          .post(`/api-r/sys/updateSys`, data2, {
            headers: { accessToken: this.userdata.token },
          })
          .then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.initial();
              this.dialogFormVisible = false;
            } else {
              alert(res.data.msg);
            }
          });
      }
    },
    sheng(val) {
      let ceshi = [];
      if (this.userdata.level == 0) {
        if (val.length == 1) {
          let ces = this.$qs.stringify({
            areasId: val[0].id,
          });
          this.$axios
            .post(`/api-r/area/getSubordinateAreaList`, ces, {
              headers: { accessToken: this.userdata.token },
            })
            .then((res) => {
              if (res.data.success) {
                this.$set(this, "citylist", res.data.areaListInfoList);
              }
            });
        } else {
          this.$set(this, "citylist", []);
        }
      } else {
        this.region.forEach((x) => {
          if (x.level == 1) {
            ceshi.push(x);
          }
        });
        this.$set(this, "citylist", ceshi);
      }
      this.$set(this, "city", "");
      this.$set(this, "area", "");
      this.$set(this, "town", "");
      this.$set(this, "village", "");
      this.$set(this, "arealist", []);
      this.$set(this, "townlist", []);
      this.$set(this, "villagelist", []);
      this.$set(this, "level", 0);
    },
    shi(val) {
      let arr = [];
      if (this.userdata.level <= 1) {
        if (val.length == 1) {
          let ces = this.$qs.stringify({
            areasId: val[0].id,
          });
          this.$axios
            .post(`/api-r/area/getSubordinateAreaList`, ces, {
              headers: { accessToken: this.userdata.token },
            })
            .then((res) => {
              if (res.data.success) {
                this.$set(this, "arealist", res.data.areaListInfoList);
              }
            });
        } else {
          this.$set(this, "arealist", []);
        }
      } else {
        this.region.forEach((x) => {
          if (x.level == 2) {
            arr.push(x);
          }
        });
        this.$set(this, "arealist", arr);
      }
      this.$set(this, "area", "");
      this.$set(this, "town", "");
      this.$set(this, "village", "");
      this.$set(this, "townlist", []);
      this.$set(this, "villagelist", []);
      this.$set(this, "level", 1);
    },
    qu(val) {
      let arr = [];
      if (this.userdata.level <= 2) {
        if (val.length == 1) {
          let ces = this.$qs.stringify({
            areasId: val[0].id,
          });
          this.$axios
            .post(`/api-r/area/getSubordinateAreaList`, ces, {
              headers: { accessToken: this.userdata.token },
            })
            .then((res) => {
              // console.log(res)
              if (res.data.success) {
                this.$set(this, "townlist", res.data.areaListInfoList);
              }
            });
        } else {
          this.$set(this, "townlist", []);
        }
      } else {
        this.region.forEach((x) => {
          if (x.level == 3) {
            arr.push(x);
          }
        });
        this.$set(this, "townlist", arr);
      }
      this.$set(this, "town", "");
      this.$set(this, "village", "");
      this.$set(this, "villagelist", []);
      this.$set(this, "level", 2);
    },
    xiang(val) {
      let arr = [];
      if (this.userdata.level <= 3) {
        if (val.length == 1) {
          let ces = this.$qs.stringify({
            areasId: val[0].id,
          });
          this.$axios
            .post(`/api-r/area/getSubordinateAreaList`, ces, {
              headers: { accessToken: this.userdata.token },
            })
            .then((res) => {
              // console.log(res)
              if (res.data.success) {
                this.$set(this, "villagelist", res.data.areaListInfoList);
              }
            });
        } else {
          this.$set(this, "villagelist", []);
        }
      } else {
        this.region.forEach((x) => {
          if (x.level == 4) {
            arr.push(x);
          }
        });
        this.$set(this, "villagelist", arr);
      }
      this.$set(this, "village", "");
      this.$set(this, "level", 3);
    },
    cun(val) {
      this.$set(this, "level", 4);
    },
  },
};
</script>
<style>
#rolelist .el-input__inner {
  margin: 10px 0;
}
#rolelist .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#rolelist .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#rolelist .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#rolelist .el-form-item__content {
  margin-left: 0 !important;
  width: 100%;
}
#rolelist .el-form-item {
  display: flex;
  align-items: center;
}
#rolelist .el-form-item {
  margin-bottom: 2px;
}
#rolelist .el-form .el-button--primary {
  width: 112px;
  margin-bottom: 18px;
  margin-right: 13px;
}
/* #rolelist .now .el-form-item__content{width: 84%;} */
#rolelist .el-dialog__body {
  height: 100%;
}
</style>
<style scoped lang="scss">
.slt {
  width: 30%;
  margin-right: 14px;
}
.dettit {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dettit > span {
  border-left: 5px solid #11A983;
  padding-left: 8px;
}
.nows {
  label {
    margin-top: -60px !important;
  }
}
</style>
